import { useState } from "react";
import { FormControl, Button, Alert } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { ethers } from "ethers";
import axios from "axios";
import Swal from "sweetalert2";
//import { Buffer } from 'buffer'
//import { create } from 'ipfs-http-client'


const { ethereum } = window;
//const projectSecret = process.env.REACT_APP_INFURA_API_KEY || ''
//const projectId = process.env.REACT_APP_INFURA_PROJECT_ID || ''
const huggingFaceKey = process.env.REACT_APP_HUGGING_FACE_KEY || "";
//const subdomain = 'https://ai-gen-nft-minter.infura-ipfs.io'
const subdomain = "https://api.thetaedgestore.com/api/v2/data";

const Create = ({ nft, provider, fetchAccountInfo }) => {
  const [textPrompt, setTextPrompt] = useState("");
  const [url, setURL] = useState(null);

  const [message, setMessage] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (textPrompt === "") {
      window.alert("Please provide a description");
      return;
    }

    setIsWaiting(true);

    const token = await createToken();

    const imageData = await createImage();

    const url = await uploadImage(imageData, token);

    // display image before minting
    setIsWaiting(false);
    await mintImage(url);

    setMessage("");
  };

  const createToken = async () => {
    if (!window.ethereum) {
      // should not reach here.
      throw "wallet not installed";
    }
    setMessage(<span className="text-success">'Creating token auth...'</span>);
    console.log("Creando token");
    const timestamp = Date.now().toString();
    const msg = "Theta EdgeStore Call " + timestamp;
    const accounts = await ethereum.request({
      method: "eth_requestAccounts",
    });
    let address = ethers.utils.getAddress(accounts[0]);
    const sig = await window.ethereum.request({
      method: "personal_sign",
      params: [msg, address],
    });

    const auth_token = timestamp + "." + address + "." + sig;
    console.log("TokenAuth: ", auth_token);
    return auth_token;
  };
  const createImage = async () => {
    setMessage(<span className="text-success">'Generating Image...'</span>);
    console.log("Creando imagen");
    try {
      const URL = `https://api-inference.huggingface.co/models/prompthero/openjourney`;

      // Send the request
      const response = await axios({
        url: URL,
        method: "POST",
        headers: {
          Authorization: `${huggingFaceKey}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          inputs: textPrompt,
          options: { wait_for_model: true },
        }),
        responseType: "arraybuffer",
      });

      const file = new Blob([response.data], { type: "image/jpeg" });
      const formData = new FormData();
      formData.append("file", file, "image.jpeg");

      return formData;
    } catch (err) {
      console.error(err);
    }
  };

  const uploadImage = async (imageData, token) => {
    setMessage(<span className="text-success">'Uploading Data...'</span>);
    console.log("Subiendo imagen");
    try {
      const url = "https://dev2-api.thetaedgestore.com/api/v2/data";
      const response = await axios.post(url, imageData, {
        headers: {
          "x-theta-edgestore-auth": `${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Response.data", response.data);
      const result = response.data;
      const keyValue = result.key;
      console.log("Key:", keyValue);

      const uri = `https://dev2-data.thetaedgestore.com/api/v2/data/${keyValue}`;
      setURL(uri);
      console.log("uri: ", uri);

      return uri;
    } catch (err) {
      console.error(err);
    }
  };

  const mintImage = async (tokenURI) => {
    try {
      setMessage(<span className="text-success">'Waiting for Mint...'</span>);

      const signer = await provider.getSigner();
      const transaction = await nft
        .connect(signer)
        .mint(tokenURI, textPrompt, { value: ethers.utils.parseEther("90") });
        Swal.fire({
          title: "Mint Process Start",
          text: "Wait a moment please",
          showConfirmButton: false,
          imageUrl:
          "https://media1.giphy.com/media/KbS9leefn8fIWFrNRe/giphy.gif?cid=6c09b952nwav8xklknm9zyqhxpokxm31mvf055pcopaleotv&ep=v1_stickers_related&rid=giphy.gif&ct=s",
          imageWidth: 200,
          imageHeight: 200,
          imageAlt: "Minteando...",
        });
      const ok = await transaction.wait();
      // update wallet with minted NFT
      if(ok) {
          fetchAccountInfo();
          Swal.fire({
            title: `You have a new NFT`,

            icon: "success",
            confirmButtonText: "Close",
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              setIsWaiting(true);
            } else if (result.isDenied) {
              window.location.reload();
            } });  
         }
    } catch (error) {
      window.alert("You rejected the transaction");
      window.location.reload();
    }
  };

  return (
    <div className="container">
      <h2 className="text-white" id="mint">
        Generate and Mint NFT
      </h2>
      <form className="row prompt" onSubmit={handleSubmit}>
        <FormControl
          type="text"
          width={250}
          placeholder="Enter a description for the image"
          value={textPrompt}
          className="my-4 withForm"
          onChange={(e) => setTextPrompt(e.target.value)}
        />
        <Button className="btn btn-success withForm" type="submit" width={250}>
          Create & Mint
        </Button>
      </form>

      <div className="image">
        {!isWaiting && url ? (
          <img src={url} alt="AI description generation" />
        ) : isWaiting ? (
          <div
            className="image__placeholder"
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Spinner animation="grow" />
            <p>{message}</p>
          </div>
        ) : (
          <span className="text-success">
            Generated Images will appear here and NFTs below
          </span>
        )}
      </div>
    </div>
  );
};

export default Create;
